<template>
  <div>
    <div class="card no-margin-bottom">
      <div class="card-block">
        <ui-data-table
          id="plans-list"
          ref="list"
          :columns="columns"
          :filters="filters"
          :endpoint="endpoint"
          :options="options"
          size="sm"
        >
          <template slot="id" slot-scope="row">
            {{ row.id }}
          </template>

          <template slot="log" slot-scope="row">
            <router-link
              class="text-primary"
              :to="{ name: 'OrderLogsDetail', params: { log_id: row.id } }"
            >
              View
            </router-link>
          </template>

          <template slot="third_party_order_id" slot-scope="row">
            {{ row.third_party_order_id ? row.third_party_order_id : '-' }}
          </template>

          <template slot="purchase_date" slot-scope="row">
            <span>{{ $getFormattedDate(row.purchase_date) }}</span>
          </template>

          <template slot="updated_date" slot-scope="row">
            <span>{{ $getFormattedDate(row.updated_date) }}</span>
          </template>

          <template slot="is_active" slot-scope="row">
            <i v-if="row.is_active" class="fa fa-check text-success" />
            <i v-else class="fa fa-remove text-danger" />
          </template>

          <template slot="actions" slot-scope="row">
            <a href="#" class="text-danger" @click.prevent="remove(row.id)">
              <i :title="$t('Delete')" class="fa fa-trash" />
            </a>
          </template>
        </ui-data-table>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import ApiService from "../services/ApiService";
import ErrorsMixins from "../mixins/ErrorsMixins";
import DateFormatFiltersMixin from "../mixins/DateFormatFiltersMixin";
export default {
  name: "AppPagePlans",
  mixins: [ErrorsMixins, DateFormatFiltersMixin],
  data() {
    return {
      columns: [
        {
          name: "ID",
          key: "id",
          sorting: true,
          styles: "text-right",
        },
        {
          name: this.$tc("Order ID", 1),
          key: "third_party_order_id",
          sorting: true,
        },
        {
          name: this.$tc("PO Number", 1),
          key: "po_number",
          sorting: true,
        },
        {
          name: this.$t("Created Date"),
          key: "purchase_date",
        },
        {
          name: this.$t("Updated Date"),
          key: "updated_date",
        },
        {
          name: this.$tc("Customer Name"),
          key: "customer_name",
          sorting: true,
        },
        {
          name: this.$tc("Status"),
          key: "status_name",
          sorting: true,
        },
        {
          name: this.$tc("Logs", 2),
          key: "log",
          sorting: true,
        },
      ],
      filters: [
        {
          name: "ID",
          key: "id",
          type: "integer",
        },
        {
          name: this.$tc("Order ID", 1),
          key: "third_party_order_id",
          type: "string",
        },
        {
          name: this.$tc("PO Number", 1),
          key: "po_number",
          type: "string",
        },
        {
          name: this.$tc("Customer Name", 1),
          key: "customer_name",
          type: "string",
        },
        {
          name: this.$tc("Status", 1),
          key: "status_name",
          type: "string",
        },
      ],
      // /orders/?account_id=1&appends=is_third_party,third_party_order_id,po_number&columns=market_id,id,shipping_method_id,status,ship_name,customer_name&search=suja&page=1&limit=10
      endpoint: `${ApiService.getLink("orders")}&account_id=${
        this.$route.params.id
      }&appends=is_third_party,third_party_order_id,po_number&columns=market_id,id,shipping_method_id,status,ship_name,customer_name,purchase_date,updated_date`,
      options: {searchable: true,},
    };
  },
  methods: {
    refresh() {
      this.$refs.list.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.role-badge {
  margin-right: 3px;
}
</style>
